export default __webpack_public_path__ + "media/feet-outline.c8813cce.png";